module.exports = __webpack_public_path__ + "img/sence-yhbz.51a1267d.png";